<template>
    <div>
        <buttonlist @help="help" @opentable="opentable" @add="add" @search="search" @reflash="reflash" @imp="imp" @exps="exps" @save="save" @del="del"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
                <el-tabs :tab-position="'top'" type="" v-model="activeName" @tab-click="selectInfo">
                    <el-tab-pane :label="$t('getapi[1484]')" name="0" id="xpane-0">
                        <wTable
                                :data="dataSet"
                                :loading="loading"
                                queryData="PurRequisitionViewInfo"
                                :filter_language="['Requisition_Status']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleCurrentChanges="handleCurrentChanges"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                :checkflg="false"
                                ref="singleTable"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet"
                                ref="singleTable"
                                v-loading="loading"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                border
                                stripe
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @current-change="handleCurrentChanges"
                                header-row-class-name="headerclass"
                                style="width: 100%; margin-top:0px"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Requisition_No" :label="$t('getapi[1480]')"
                                             width="150"  sortable>
                                <template scope="scope">
                                    <input
                                            type="text"
                                            class="fsd clerinput"
                                            @keydown="keydown($event, scope.$index)"
                                            @keyup="keyup($event, scope.row)"
                                            v-model="scope.row.Requisition_No"
                                            readonly
                                    />
                                </template>
                            </el-table-column>
                            &lt;!&ndash;label="计划标识"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Requisition_Type" :label="$t('getapi[3628]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划类型"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Item_code" :label="$t('getapi[4158]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="项目"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Requisition_Status" :label="$t('getapi[1477]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划状态"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[163]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划员"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[1478]')"
                                             width="150" sortable></el-table-column>
                            &lt;!&ndash;label="计划时间"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[1481]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="批准者"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[551]')"
                                             width="150" sortable></el-table-column>
                            &lt;!&ndash;label="批准时间"&ndash;&gt;
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1485]')" name="1" id="xpane-1">
                        <wTable
                                :data="dataSet1"
                                :loading="loading"
                                queryData="PurRequisitionViewInfo"
                                :filter_language="['Requisition_Status']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleCurrentChanges="handleCurrentChanges1"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                :checkflg="false"
                                ref="singleTable1"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet1"
                                ref="singleTable1"
                                border
                                size="mini"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                stripe
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @current-change="handleCurrentChanges1"
                                header-row-class-name="headerclass"
                                style="width: 100%"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Requisition_No" :label="$t('getapi[1480]')"
                                             width="150"  sortable>
                                <template scope="scope">
                                    <input
                                            type="text"
                                            class="fsd1 clerinput"
                                            @keydown="keydown1($event, scope.$index)"
                                            @keyup="keyup($event, scope.row)"
                                            v-model="scope.row.Requisition_No"
                                            readonly
                                    />
                                </template>
                            </el-table-column>
                            &lt;!&ndash;label="计划标识"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Requisition_Type" :label="$t('getapi[3628]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划类型"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Item_code" :label="$t('getapi[4158]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="项目"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Requisition_Status" :label="$t('getapi[1477]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划状态"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[163]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划员"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[1478]')"
                                             width="150" sortable></el-table-column>
                            &lt;!&ndash;label="计划时间"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[1481]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="批准者"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[551]')"
                                             width="150" sortable></el-table-column>
                            &lt;!&ndash;label="批准时间"&ndash;&gt;
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1488]')" name="2" id="xpane-2">
                        <wTable
                                :data="dataSet2"
                                :loading="loading"
                                queryData="PurRequisitionViewInfo"
                                :filter_language="['Requisition_Status']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleCurrentChanges="handleCurrentChanges2"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                :checkflg="false"
                                ref="singleTable2"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet2"
                                ref="singleTable2"
                                border
                                size="mini"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                stripe
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @current-change="handleCurrentChanges2"
                                header-row-class-name="headerclass"
                                style="width: 100%"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Requisition_No" :label="$t('getapi[1480]')"
                                             width="150"  sortable>
                                <template scope="scope">
                                    <input
                                            type="text"
                                            class="fsd2 clerinput"
                                            @keydown="keydown2($event, scope.$index)"
                                            @keyup="keyup($event, scope.row)"
                                            v-model="scope.row.Requisition_No"
                                            readonly
                                    />
                                </template>
                            </el-table-column>
                            &lt;!&ndash;label="计划标识"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Requisition_Type" :label="$t('getapi[3628]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划类型"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Item_code" :label="$t('getapi[4158]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="项目"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Requisition_Status" :label="$t('getapi[1477]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划状态"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[163]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划员"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[1478]')"
                                             width="150" sortable></el-table-column>
                            &lt;!&ndash;label="计划时间"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[1481]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="批准者"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[551]')"
                                             width="150" sortable></el-table-column>
                            &lt;!&ndash;label="批准时间"&ndash;&gt;
                        </el-table>-->
                    </el-tab-pane>
                    <el-tab-pane :label="$t('getapi[1487]')" name="3" id="xpane-3">
                        <wTable
                                :data="dataSet3"
                                :loading="loading"
                                queryData="PurRequisitionViewInfo"
                                :filter_language="['Requisition_Status']"
                                :header="tableHeader"
                                :option="tableOption"
                                @handleCurrentChanges="handleCurrentChanges3"
                                @edits="editInfo"
                                @rowdblclick="openEdit"
                                :checkflg="false"
                                ref="singleTable3"
                        ></wTable>
                        <!--<el-table
                                :data="dataSet3"
                                ref="singleTable3"
                                border
                                size="mini"
                                :height="tableHeight - reduceTableHeight"
                                @row-click="editInfo"
                                @row-dblclick="openEdit"
                                @current-change="handleCurrentChanges3"
                                :highlight-current-row="true"
                                show-overflow-tooltip="true"
                                stripe
                                header-row-class-name="headerclass"
                                style="width: 100%"
                        >
                            <el-table-column type="selection" v-if="false"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Requisition_No" :label="$t('getapi[1480]')"
                                             width="150"  sortable>
                                <template scope="scope">
                                    <input
                                            type="text"
                                            class="fsd3 clerinput"
                                            @keydown="keydown3($event, scope.$index)"
                                            @keyup="keyup($event, scope.row)"
                                            v-model="scope.row.Requisition_No"
                                            readonly
                                    />
                                </template>
                            </el-table-column>
                            &lt;!&ndash;label="计划标识"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Requisition_Type" :label="$t('getapi[3628]')"
                                             width="80"  sortable></el-table-column>
                            &lt;!&ndash;label="计划类型"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Item_code" :label="$t('getapi[4158]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="项目"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Requisition_Status" :label="$t('getapi[1477]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划状态"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Create_Person" :label="$t('getapi[163]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="计划员"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Create_time" :label="$t('getapi[1478]')"
                                             width="150" sortable></el-table-column>
                            &lt;!&ndash;label="计划时间"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Audit_Person" :label="$t('getapi[1481]')"
                                             width="80" sortable></el-table-column>
                            &lt;!&ndash;label="批准者"&ndash;&gt;
                            <el-table-column show-overflow-tooltip prop="Audit_Time" :label="$t('getapi[551]')"
                                             width="150" sortable></el-table-column>
                            &lt;!&ndash;label="批准时间"&ndash;&gt;
                        </el-table>-->
                    </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <!--<el-button type="primary" size="mini" @click="showAddBom('')" :disabled="!btn.add">{{ $t('getapi[6092]') }}</el-button>-->
                        <el-button type="primary" size="mini" @click="updateStaticCols" :disabled="addoredit == 1">{{ $t('getapi[8761]') }}
                        </el-button>
                    </div>
                    <div style="width:670px;min-width:670px">
                        <table>
                            <tr>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[1480]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input v-model="dataDetail.Head.requisition_no" type="text" size="mini"
                                              class="mcolor" v-if="dataDetail.Head.requisition_status == 0"></el-input>
                                    <el-input v-model="dataDetail.Head.requisition_no" type="text" size="mini"
                                              :readonly="true" class="readO" v-if="dataDetail.Head.requisition_status != 0"></el-input>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[3628]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-select filterable v-model="dataDetail.Head.requisition_type_id" @change="plantype"
                                               size="mini" :disabled="dataDetail.Head.requisition_status != 0" v-if="dataDetail.Head.requisition_type_id!=1">
                                        <el-option v-for="item in PlanTypeArray" :key="item.Code" :label="item.Name"
                                                   :value="item.Code"></el-option>
                                    </el-select>
                                    <el-select filterable v-model="dataDetail.Head.requisition_type_id"
                                               size="mini" :disabled="true" v-if="dataDetail.Head.requisition_type_id==1">
                                        <el-option v-for="item in AllPlanTypeArray" :key="item.Code" :label="item.Name"
                                                   :value="item.Code"></el-option>
                                    </el-select>
                                </td>
                                <td style="width:60px;min-width:60px">{{ $t('getapi[115]') }}</td>
                                <td style="width:150px;min-width:150px">
                                    <el-input value="1" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[1477]') }}</td>
                                <td>
                                    <!--{{expStatus(dataDetail.Head.requisition_status)}}-->
                                    <el-input :value="expStatus(dataDetail.Head.requisition_status)" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[1479]') }}</td>
                                <td>
                                    <routejump :urlNo="5" v-if="dataDetail.Head.requisition_status == 0">
                                    <el-input
                                            v-model="dataDetail.Head.item_code"
                                            type="text"
                                            readonly
                                            class="mcolor"
                                            size="mini"
                                    >
                                        <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectItem_code()"></i>
                                    </el-input>
                                    </routejump>
                                    <el-input v-model="dataDetail.Head.item_code" type="text" size="mini" :readonly="true" class="readO"
                                              v-if="dataDetail.Head.requisition_status != 0"></el-input>
                                </td>
                                <td>{{ $t('getapi[163]') }}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.create_person" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[409]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.create_time" size="mini" style="width:100%"
                                                    :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[576]') }}</td>
                                <td>
                                    <el-date-picker v-model="dataDetail.Head.audit_time" size="mini" style="width:100%"
                                                    :readonly="true" class="readO"></el-date-picker>
                                </td>
                                <td>{{ $t('getapi[1481]') }}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.audit_person" type="text" size="mini"
                                              :readonly="true" class="readO"></el-input>
                                </td>
                                <td>{{ $t('getapi[7003]') }}</td>
                                <td>
                                    <el-input v-model="dataDetail.Head.totam_amount" type="number" autocomplete="off" title="" @mousewheel.native.prevent size="mini" style="width:120px" :readonly="true" class="readO"></el-input>CNY
                                </td>
                            </tr>
                            <tr>
                                <td>{{ $t('getapi[12997]') }} </td>
                                <td colspan="8"><el-input  type="textarea" 
                                    :rows="1" style="width:100%" show-word-limit placeholder="申购说明" v-model="dataDetail.Head.pur_request_inst"></el-input></td>
                            </tr>
                        </table>
                    </div>
                    <div class="btnnowrap">
                        <!--<el-button type="primary" size="mini" @click="showAddBom('')" :disabled="!btn.add">{{ $t('getapi[6092]') }}</el-button>-->
                        <el-button type="primary" size="mini" @click="showAddBatchBom" :disabled="!btn.batch">{{
                            $t('getapi[6092]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="copyByOld" :disabled="!btn.copy">{{$t('getapi[1516]')}}
                        </el-button>
                        <el-button type="primary" size="mini" @click="planRelease" :disabled="!btn.release">{{
                            $t('getapi[1482]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="planReturn" :disabled="!btn.create">{{
                            $t('getapi[1521]') }}
                        </el-button>
                        <el-button type="primary" size="mini" @click="batchDel" :disabled="!btn.rowdel">{{
                            $t('getapi[1522]') }}
                        </el-button>
                    </div>
                    <div  id="xdetilpane-0">
                    <vxe-table
                            ref="singleTable4"
                            :data="dataDetail.Lists"
                            :height="tableHeight - 170"
                            border
                            size="mini"
                            resizable
                            :row-class-name="tableRowClassName"
                            @checkbox-change="handleSelectionChange"
                            @checkbox-all="handleSelectionChange"
                            @select="pinSelect"
                            header-row-class-name="headerclass"
                            :highlight-current-row="true"
                            @sort-change="sortChange"
                            @cell-click="editDetailInfo"
                            style="width: 100%; margin-top:3px"
                    >
                        <vxe-table-column type="checkbox" width="40" align="center"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="row_number" :title="$t('getapi[1425]')"
                                         align="right" sortable="custom"></vxe-table-column>
                        <vxe-table-column field="part_code" :title="$t('getapi[112]')" width="150" sortable="custom">
                            <!--title="物料编码"-->
                            <template scope="scope" v-if="dataDetail.Head.requisition_status == 0">
                                <el-input v-model="scope.row.part_code" type="text"
                                          readonly
                                          size="mini">
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddBom(scope)"></i>
                                </el-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-footer-overflow field="part_version"
                                         :title="$t('getapi[149]')" sortable="custom" width="80"></vxe-table-column><!--title="物料版本"-->
                        <vxe-table-column field="plan_qty" :title="$t('getapi[1504]')"
                                         align="right" sortable="custom" width="80"><!--title="计划采购数量"-->
                            <template scope="scope">
                                <el-input  v-if="dataDetail.Head.requisition_status == 0" v-focus :ref="scope.row.index" size="mini" v-model="scope.row.plan_qty" type="number" autocomplete="off" title="" @mousewheel.native.prevent @change="getPurRec(scope.row)"></el-input>
                                <span v-if="dataDetail.Head.requisition_status != 0">{{scope.row.plan_qty}}</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column field="expect_ship_date" :title="$t('getapi[1505]')"
                                         width="150" sortable="custom"><!--title="期望交货日期"-->
                            <template scope="scope">
                                <el-date-picker v-model="scope.row.expect_ship_date" size="mini"
                                                style="width:100%" @change="getRDate(scope)" v-if="dataDetail.Head.requisition_status == 0"></el-date-picker>
                                <span v-if="dataDetail.Head.requisition_status != 0">{{scope.row.expect_ship_date | toDate}}</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-footer-overflow field="jieyu" :title="$t('getapi[6812]')" align="right" sortable="custom" width="80"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="part_name"
                                         :title="$t('getapi[116]')" sortable="custom" width="80"></vxe-table-column><!--title="物料名称"-->
                        <vxe-table-column field="billcode" :title="$t('getapi[13499]')" width="150" sortable="custom">
                            <!--title="申购单号"-->
                            <template scope="scope" >
                                <el-input v-model="scope.row.billcode" type="text"
                                          readonly
                                          size="mini"
                                          v-if="dataDetail.Head.requisition_status == 0">
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showAddBill(scope)"></i>
                                </el-input>
                                <span v-if="dataDetail.Head.requisition_status != 0">{{scope.row.billcode}}</span>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-footer-overflow field="specification"
                                         :title="$t('getapi[125]')" sortable="custom" width="80"></vxe-table-column><!--title="规格"-->
                        <vxe-table-column show-footer-overflow field="model"
                                         :title="$t('getapi[124]')" sortable="custom" width="80"></vxe-table-column><!--title="型号"-->
                        <vxe-table-column show-footer-overflow field="part_stuff"
                                         :title="$t('getapi[126]')" sortable="custom" width="80"></vxe-table-column><!--title="材质"-->
                        <vxe-table-column show-footer-overflow field="purchase_leadtime" :title="$t('getapi[1520]')"
                                         align="right" sortable="custom"></vxe-table-column><!--title="采购周期"-->
                        <vxe-table-column show-footer-overflow field="line_status"
                                         :title="$t('getapi[552]')" sortable="custom" width="80"></vxe-table-column><!--title="状态"-->

                        <vxe-table-column show-footer-overflow field="check_std_code"
                                         :title="$t('getapi[186]')" sortable="custom" width="80"></vxe-table-column><!--title="检验标准"-->
                        <vxe-table-column show-footer-overflow field="material_std_code"
                                         :title="$t('getapi[189]')" sortable="custom" width="80"></vxe-table-column><!--title="材质标准"-->
                        <vxe-table-column show-footer-overflow field="pur_measurementunit"
                                         :title="$t('getapi[1340]')" sortable="custom" width="80"></vxe-table-column><!--title="库存计量单位"-->
                        <vxe-table-column show-footer-overflow field="already_pur_qty" :title="$t('getapi[1508]')"
                                         align="right" sortable="custom" width="80"></vxe-table-column><!--title="已采购数量"-->
                        <vxe-table-column show-footer-overflow field="inventory_qty" :title="$t('getapi[1506]')"
                                         align="right" sortable="custom" width="80"></vxe-table-column><!--title="当前库存量"-->
                        <vxe-table-column field="remark" :title="$t('getapi[143]')" sortable="custom" width="80">
                            <!--title="备注"-->
                            <template scope="scope">
                                <el-input size="mini" v-model="scope.row.remark"></el-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-footer-overflow field="mrp_qty" :title="$t('getapi[1510]')"
                                         align="right" sortable="custom" width="80"></vxe-table-column><!--title="MRP数量"-->
                        <vxe-table-column show-footer-overflow field="mrp_time"
                                         :title="$t('getapi[1511]')" sortable="custom" width="80"></vxe-table-column><!--title="MRP时间"-->
                        <vxe-table-column show-footer-overflow field="purrec" :title="$t('getapi[12521]')" sortable="custom" width="80">
                        </vxe-table-column>
                        <vxe-table-column show-footer-overflow field="products"
                                         :title="$t('getapi[145]')" sortable="custom" width="80"></vxe-table-column><!--title="所属产品"-->
                        <vxe-table-column show-footer-overflow field="key_flag"
                                         :title="$t('getapi[146]')" sortable="custom" width="80"></vxe-table-column><!--title="关键件"-->
                        <vxe-table-column show-footer-overflow field="item_type"
                                         :title="$t('getapi[118]')" sortable="custom" width="80"></vxe-table-column><!--title="工程类别"-->
                        <vxe-table-column show-footer-overflow field="net_unit_price"
                                         :title="$t('getapi[3711]')" v-if="authority_showprice" align="right" sortable="custom" width="80"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="total_amount"
                                         :title="$t('getapi[3712]')" v-if="authority_showprice" align="right" sortable="custom" width="80"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="currency_code"
                                         :title="$t('getapi[3108]')" v-if="authority_showprice" sortable="custom" width="80"></vxe-table-column>

                        <vxe-table-column field="deviceid" :title="$t('getapi[8762]')" width="120" sortable="custom">
                            <template scope="scope" v-if="dataDetail.Head.requisition_status != 1">
                                <el-input
                                        v-model="scope.row.deviceid"
                                        type="text"
                                        size="mini"
                                        class="mcolor"
                                        readonly
                                >
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="showdeviceid(scope)"></i>
                                </el-input>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-footer-overflow field="stock_qty" :title="$t('getapi[4567]')" align="right" sortable="custom" width="80"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="demand_qty" :title="$t('getapi[8763]')" align="right" sortable="custom" width="80"></vxe-table-column>
                        <vxe-table-column show-footer-overflow field="on_qty" :title="$t('getapi[1620]')" align="right" sortable="custom" width="80"></vxe-table-column>
                        <vxe-table-column field="consumption_date" :title="$t('getapi[1512]')"
                                         width="150" sortable="custom"><!--title="预计消耗日期"-->
                            <template scope="scope" v-if="dataDetail.Head.requisition_status == 0">
                                <el-date-picker size="mini" v-model="scope.row.consumption_date"></el-date-picker>
                            </template>
                        </vxe-table-column>
                        <vxe-table-column show-footer-overflow field="tiersprice" :title="$t('getapi[13280]')" sortable="custom" width="200" :show-overflow="true"></vxe-table-column>
                        <!--<el-table-column fixed="right" :label="$t('basic.edit')" width="60">
                            <template slot-scope="scope">
                                <el-button @click.native.prevent="editInfo1(scope.row)" type="text" size="small">{{
                                    $t('getapi[1482]') }}
                                </el-button>
                                <el-button @click.native.prevent="editInfo2(scope.row)" type="text" size="small">{{
                                    $t('getapi[1521]') }}
                                </el-button>
                                <el-button @click.native.prevent="editInfo3(scope.row)" type="text" size="small">{{
                                    $t('getapi[1521]') }}
                                </el-button>
                            </template>
                        </el-table-column>-->
                    </vxe-table>
                    </div>
                </div>
            </li>
        </ul>
        <el-row v-if="selectIndex == 0" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="selectIndex == 1" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize1"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total1"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="selectIndex == 2" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize2"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total2"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <el-row v-if="selectIndex == 3" class="page">
            <el-col :span="18">
                <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[100, 200, 300, 400]"
                        :page-size="pageSize3"
                        :pager-count="5"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total3"
                ></el-pagination>
            </el-col>
            <el-col :span="6">
                <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
                    }}
                </div>
            </el-col>
        </el-row>
        <serce :isVisible="isVisible" queryData="PurRequisitionViewInfo" ref="ser" @getser="serclick"></serce>
        <ctable :isVisible="false" :title="$t('getapi[1138]')" queryData="PurRequisitionViewInfo" tabNo="0" ref="ctab"
                @getctab="sortclick"></ctable>

        <!--<itemCode :isVisible="isShowItem" @getproject="getproject" ref="input"></itemCode>-->
        <selector :isVisible="isShowItem" :selectType="3" :isBatch=false :isSplitPage=true :postUrl="'/Basic/Popup/GetEngItemDataList'"
                  @callback="getproject" ref="input"></selector>
        <!-- 新增物料弹框 -->
        <!--<OM :isVisible="addbomvisible" @addmaterials="addmaterials" ref="addmaterials"></OM>-->
        <selector :isVisible="isShowItem" :selectType="5" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="addmaterials" ref="addmaterial"></selector>
        <selector :isVisible="isShowItem" :selectType="5" :isBatch=true :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="addmaterials" ref="addmaterials"></selector>
        <selector :isVisible="false" :selectType="21" :isBatch=false :isSplitPage=true
                  :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="addbill" ref="addbill"></selector>
        <!-- 从旧计划选择 -->
        <!--<purcopyoldplan :isVisible="isShowCopy" @copy="copy" ref="copy"></purcopyoldplan>-->
        <selector :isVisible="isShowCopy" :isBatch=false :isSplitPage=true
                  :postUrl="'/Pur/Requisition/GetOldPurSchemePopupList'" @callback="copy" ref="copy"></selector>

        <selector :isVisible="false" :isBatch=false :isSplitPage=true
                  :postUrl="'/Pur/Requisition/GetPurSchemeDevicePopupList'" @callback="getdevice"
                  ref="device"></selector>
    </div>
</template>

<script>
    import Common from '@/components/Common';
    import Array from '@/components/Array';
    import array from '@/api/array.js';
    import { Loading } from 'element-ui';
    export default {
        name: 'purschemeview',
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                    maxHeight: this.$windowSize.tableHeight3-Common.reduceTableHeight2,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                tableHeader: [],
                origin: -1, // 起点数
                pin: false, // 默认shift不按住
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
                scrollTop3:0,
                scrollTop4:0,
                dataSet: [], // 主表数据0 全部、 1 生成、 2 下达、 3 已下单
                dataSet1: [], // 主表数据
                dataSet2: [], // 主表数据
                dataSet3: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                pageIndex: 1, // 当前页
                RightselectIndex: 0,
                pageSize: this.$http.getPageSize('purschemeview'), // 当前页数据量
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('purschemeview1'), // 当前页数据量
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('purschemeview2'), // 当前页数据量
                pageIndex3: 1, // 当前页
                pageSize3: this.$http.getPageSize('purschemeview3'), // 当前页数据量
                selectIndex: 0, //当前页面
                oldselectIndex: 0,
                total: 0, // 数据总量
                total1: 0, // 数据总量
                total2: 0, // 数据总量
                total3: 0, // 数据总量
                loading: false, // 主表加载状态
                reduceTableHeight: Common.reduceTableHeight2,
                isShowEdit: false, // 是否显示编辑页面
                dataDetail: {
                    Head: {},
                    Lists: [],
                }, // 编辑页面数据详情
                oldDataDetail: '',
                Requisition_No: '',
                PlanTypeArray: [], // 计划类型数组
                AllPlanTypeArray:[],//计划类型所有数组
                isBtnPlan: true,
                isBtnPlanReturn: true,
                isBtnDel: true,
                selectData: [],
                dataChecked: [],
                isShowItem: false, // 是否显示项目信息
                addbomvisible: false, //批量选择物料

                isShowCopy: false, //从旧计划选择
                oneormore: -1, // 1:单选2：多选
                addoredit: -1, // 1.新增2：编辑
                rowindex: -1,
                currentRow: null,
                currentRow1: null,
                currentRow2: null,
                currentRow3: null,
                btn: {
                    //新增物料
                    add: true,
                    //批量选择
                    batch: true,
                    //拷贝
                    copy: true,
                    //下达
                    release: true,
                    //返回生成
                    create: true,
                    //删除明细
                    rowdel: true
                },
                dataDetailLineNo: 1,
                rowindexdevice: -1,
                authority_showprice: false, // 权限——是否显示价格
                mro_only: false, // 权限——仅mro计划
                mro_no: false, // 权限——非mro计划
                BatchPriceLine: [], // 物料批量下限数据
                activeName: 0,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                canEnter: false, //是否开启监听回车事件
            };
        },
        beforeRouteEnter(to, form, next) {
            next(vm => {
                if (form.name == 'purbusiness' && Object.keys(vm.$store.state.sharedParams).length > 0) {
                    const data = {...vm.$store.state.sharedParams};
                    vm.getDetail(data.order_no);
                    setTimeout(() => {
                        vm.openEdit()
                    }, 500);
                    vm.$store.commit('clearSharedParams')
                }
            });
        },
        mounted: function () {
            let that = this;
            that.colsort();
            that.$processdata.pushModelCache('purschemeview', that)
            that.userData = sessionStorage.getItem('userData');
            that.PlanTypeArray = Array.methods.getPlanType();
            that.AllPlanTypeArray = Array.methods.getAllPlanType();
            that.$limits.dragControllerDiv();
            that.oldDataDetail = JSON.stringify(that.dataDetail)
            that.confirmAdd();

            window.addEventListener('keydown', code => { // 这个是获取键盘按住事件
                console.log(code) // 这个是你按住键盘打印出键盘信息，在浏览器中自行查看
                if (code.keyCode === 16 && code.shiftKey) { // 判断是否按住shift键，是就把pin赋值为true
                    this.pin = true
                }
                if(code.keyCode === 13){
                    console.log(that.rowindex)
                    if((that.rowindex > that.dataDetail.Lists.length - 2 || that.rowindex == -1) && that.dataDetail.Lists.length > 0){
                        that.rowindex = -1
                    }
                    this.$refs.singleTable4.setCurrentRow(that.dataDetail.Lists[++that.rowindex]);
                    /*let name = ++that.rowindex
                    this.$refs.name.focus()*/
                }
            })
            window.addEventListener('keyup', code => { // 这个是获取键盘松开事件
                if (code.keyCode === 16) { // 判断是否松开shift键，是就把pin赋值为false
                    this.pin = false
                }
            })
            that.$nextTick(function () {
                that.$processdata.initForm()
                that.$processdata.initFormRight()
            })
            /*that.PlanTypeArray = Array.methods.getPlanType();*/
        },
    activated () {   // 路由跳转回来滚动到离开时的位置
        let that = this
        setTimeout(() => {
            that.$refs.singleTable.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                let height = res.target
                that.scrollTop = height.scrollTop
            },false)
            that.$refs.singleTable1.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop1 = res.target.scrollTop
            },false)
            that.$refs.singleTable2.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop2 = res.target.scrollTop
            },false)
            that.$refs.singleTable3.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                that.scrollTop3 = res.target.scrollTop
            },false)
            this.$refs.singleTable4.bodyWrapper.addEventListener('scroll', (res) => {
                //console.log('444'+res.target.scrollTop);
                this.scrollTop4 = res.target.scrollTop
            },false)
        }, 3000);
        this.$nextTick(()=> {
            setTimeout(() => {
                this.$refs.singleTable.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                this.$refs.singleTable1.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop1;
                this.$refs.singleTable2.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop2;
                this.$refs.singleTable3.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop3;
                this.$refs.singleTable4.bodyWrapper.scrollTop =this.scrollTop4;
            }, 13)
        })

    },
        methods: {
            colsort() {
                let that = this;
                that.$loadviewfields.Fileds('PurRequisitionViewInfo', 0, PFileds => {
                    that.tableHeader = PFileds;
                });
            },
            sortclick(val) {
                if (val == 1) {
                    this.colsort();
                }
            },
            // 修改表格顺序
            opentable() {
                this.$refs.ctab.clearInputs(true);
            },
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[1138]"),this.$t("getapi[16]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                that.$refs.SetBtn.SetOneBtnEnable('ctabel', true);
                // 是否现实金额
                if(that.$limits.authority('plv4', 158, 1) ==  1){
                    that.authority_showprice = true
                } else {
                    that.authority_showprice = false
                }
                // 仅MRO
                if(that.$limits.authority('plv4', 120, 1) > 0){
                    that.mro_only = true
                } else {
                    that.mro_only = false
                }
                // 非MRO
                if(that.$limits.authority('plv4', 121, 1) > 0){
                    that.mro_no = true
                } else {
                    that.mro_no = false
                }
                if(that.mro_only && that.mro_no){
                    that.mro_only = false
                    that.mro_no = false
                }
                // 一览，管理权限控制
                if(!this.$limits.menuvisible("plv2", 58, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 57, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 58, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh');
                    }
                    if (that.$limits.authority('plv2', 58, 1) == 2) {
                        if (that.$limits.authority('plv3', 58,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 58,1) == 1) {
                            //编辑级
                            that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                        }
                        if (that.$limits.authority('plv3', 58, 1) == 2) {
                            //删除级
                            if (!that.$limits.fnIsEmpty(that.dataDetail.Head.requisition_no)) {
                                if (that.dataDetail.Head.requisition_status == 1 || that.dataDetail.Head.requisition_status == 2) {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                                } else {
                                    that.$refs.SetBtn.SetButtonEnable('create,save,del,search,refresh,export');
                                }
                            } else {
                                that.$refs.SetBtn.SetButtonEnable('create,save,search,refresh,export');
                            }
                        }
                    }
                }
                that.$refs.SetBtn.InputBtnRight('T06_Requisition');
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                if (that.dataDetail.Head.requisition_status == 1 || that.dataDetail.Head.requisition_status == 2) {
                    that.btn.add = false;
                    that.btn.batch = false;
                    that.btn.copy = false;
                } else {
                    that.btn.add = true;
                    that.btn.batch = true;
                    that.btn.copy = true;
                }

                if (that.dataDetail.Head.requisition_type == 'MRP计划') {
                    that.btn.add = false;
                    that.btn.batch = false;
                    that.btn.copy = false;
                }

                that.selectbtn();
            },
            getRDate(val) {
                //返回格式为yyyy-MM-dd
                val.row.expect_ship_date = this.$limits.GetCurrentDate(val.row.expect_ship_date);
            },
            selectbtn() {
                let that = this;

                if (that.$limits.fnIsEmpty(that.dataDetail.Head.requisition_no)) {
                    that.btn.release = false;
                } else {
                    that.btn.release = true;
                }
                // console.log("测试1");
                if (that.selectData.length == 0) {
                    that.btn.release = false;
                    that.btn.create = false;
                    that.btn.rowdel = false;
                    return;
                }
                // console.log("测试2");
                for (let i = 0; i < that.selectData.length; i++) {
                    if (that.selectData[i].isadd == 1) {
                        that.btn.release = false;
                        that.btn.create = false;
                        that.btn.rowdel = true;
                        return;
                    }
                }
                // console.log("测试3");
                if (that.selectData.length > 1) {
                    for (let i = 0; i < that.selectData.length - 1; i++) {
                        if (that.selectData[i].line_status != that.selectData[i + 1].line_status) {
                            that.btn.release = false;
                            that.btn.create = false;
                            that.btn.rowdel = false;
                            return;
                        }
                    }
                }
// console.log("测试4");
                if (that.$limits.authority('plv3', 58, 1) == 0) {
                    //查询级
                    that.btn.release = false;
                    that.btn.create = false;
                    that.btn.rowdel = false;
                }
                // console.log("测试5");
                if (that.$limits.authority('plv3', 58, 1) > 0) {
                    if (that.$limits.authority('plv4', 20, 1) == 0) {
                        //查询级
                        that.btn.release = false;
                    } else {
                        if(that.mro_only && !that.dataDetail.Head.requisition_type.toUpperCase().includes('MRO')){
                            that.btn.release = false;
                        }
                        if(that.mro_no && that.dataDetail.Head.requisition_type.toUpperCase().includes('MRO')){
                            that.btn.release = false;
                        }
                        if (that.selectData[0].line_status == "下达") {
                            //"下达"
                            that.btn.release = false;
                        }
                        if (that.selectData[0].line_status == "已下单") {
                            //"已下单"
                            that.btn.release = false;
                        }
                        if (that.selectData[0].line_status == "生成") {
                            //"生成"
                            that.btn.release = true;
                        }
                    }
// console.log("测试6");
                    //计划返回生成权限设置
                    if (that.$limits.authority('plv4', 21, 1) == 0) {
                        that.btn.create = false;
                    } else {
                        if (that.selectData[0].line_status == "下达") {
                            //"下达"
                            that.btn.create = true;
                        }
                        if (that.selectData[0].line_status == "已下单") {
                            //"已下单"
                            that.btn.create = false;
                        }
                        if (that.selectData[0].line_status == "生成") {
                            //"生成"
                            that.btn.create = false;
                        }
                    }
                    // console.log("测试7");
                    // console.log("测试71"+that.selectData[0].line_status);
                    //删除计划行权限设置
                    if (that.$limits.authority('plv4', 22, 1) == 0) {
                        that.btn.rowdel = false;
                    } else {

                        if (that.selectData[0].line_status == "下达") {
                            //"下达"
                            that.btn.rowdel = false;
                        }
                        if (that.selectData[0].line_status == "已下单") {
                            //"已下单"
                            that.btn.rowdel = false;
                        }
                        if (that.selectData[0].line_status == "生成") {
                            //"生成"
                            that.btn.rowdel = true;
                        }
                    }
                }
            },
            plantype(val) {
                let that = this;
                var IsExists = false;
                for (var i = 0; i < that.PlanTypeArray.length; i++) {
                    if (that.PlanTypeArray[i].Code == val) {
                        console.log('cehsi111:' + that.PlanTypeArray[i].Name);
                        // planname = that.PlanTypeArray[i].Name;
                        that.dataDetail.Head.requisition_type = that.PlanTypeArray[i].Name;
                    }
                }
            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            keyup(ev, row) {
                let that = this;
                that.editInfo(row);
            },
            keydown(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet[index - 1];
                    that.setCurrent(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet[index + 1];
                    that.setCurrent(tds);
                }
            },
            setCurrent(row) {
                this.$refs.singleTable.setCurrentRow(row);
            },
            handleCurrentChanges(val) {
                if (val != null) {
                    let that = this;
                    let result = this.dataSet.findIndex(item => item.Requisition_No === val.Requisition_No);
                    let fsd = document.getElementsByClassName('fsd');
                    fsd[result].focus();
                    that.currentRow = val;
                }
            },
            keydown1(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet1[index - 1];
                    that.setCurrent1(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet1[index + 1];
                    that.setCurrent1(tds);
                }
            },
            setCurrent1(row) {
                this.$refs.singleTable1.setCurrentRow(row);
            },
            handleCurrentChanges1(val) {
                let that = this;
                let result = this.dataSet1.findIndex(item => item.Requisition_No === val.Requisition_No);
                let fsd = document.getElementsByClassName('fsd1');
                fsd[result].focus();
                that.currentRow1 = val;
            },
            keydown2(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet2[index - 1];
                    that.setCurrent2(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet2[index + 1];
                    that.setCurrent2(tds);
                }
            },
            setCurrent2(row) {
                this.$refs.singleTable2.setCurrentRow(row);
            },
            handleCurrentChanges2(val) {
                let that = this;
                let result = this.dataSet2.findIndex(item => item.Requisition_No === val.Requisition_No);
                let fsd = document.getElementsByClassName('fsd2');
                fsd[result].focus();
                that.currentRow2 = val;
            },
            keydown3(ev, index) {
                let that = this;
                if (ev.keyCode == 38) {
                    let tds = that.dataSet3[index - 1];
                    that.setCurrent3(tds);
                }
                if (ev.keyCode == 40) {
                    let tds = that.dataSet3[index + 1];
                    that.setCurrent3(tds);
                }
            },
            setCurrent3(row) {
                this.$refs.singleTable3.setCurrentRow(row);
            },
            handleCurrentChanges3(val) {
                let that = this;
                let result = this.dataSet3.findIndex(item => item.Requisition_No === val.Requisition_No);
                let fsd = document.getElementsByClassName('fsd3');
                fsd[result].focus();
                that.currentRow3 = val;
            },
            //表格背景
            tableRowClassName({row, rowIndex}) {
                row.index = rowIndex;
                // if (row.minbatchprice_color > 0) {
                //     let row1 = this.BatchPriceLine.find(item => item.part_code == row.part_code && item.part_version == row.part_version && item.batch_floor_limit > row.plan_qty)
                //     if(!this.$limits.fnIsEmpty(row1)){
                //         return 'yellow'
                //     } else{
                //         return 'green';
                //     }
                // } else if (row.batchprice == '有' && row.plan_qty > 0) {
                //     return 'red';
                // }
                if (row.moq > row.plan_qty && row.maxbatchprice_color>0) {
                    return 'red';
                } 
                else if (row.maxbatchprice_color>row.plan_qty && row.plan_qty>=row.moq && row.maxbatchprice_color>0) {
                    return 'yellow';
                }
                else if(row.maxbatchprice_color<=row.plan_qty && row.maxbatchprice_color>0){
                    return 'green';
                }

                if (row.isdel == 1) {
                    return 'hidden';
                }
            },
            getPurRec(row){
                let that = this
                let parm = {
                    part_code: row.part_code,
                    part_version: row.part_version,
                }
                that.$http.urlpost('/Pur/Requisition/GetBatchPriceData', parm, function (res) {
                    if (res.Success == 1) {
                        let data = res.DataContent.BatchPriceLine
                        let price = row.net_unit_price
                        for(let j=0;j<data.length;j++){
                            if(row.plan_qty >=data[j].batch_floor_limit){
                                price = data[j].net_price
                            }
                        }
                        let row1 = data.find(item => item.part_code == row.part_code && item.part_version == row.part_version && item.batch_floor_limit > row.plan_qty)
                        if(row1 != undefined){
                            if((row.plan_qty * price) >= (row1.batch_floor_limit * row1.net_price * 0.8)){
                                row.purrec = that.$t('getapi[12522]')
                                that.$confirm(that.$t('getapi[12522]'), that.$t('getapi[194]'), {
                                    confirmButtonText: that.$t('getapi[1146]')
                                })
                            }
                        }
                    }
                });
            },
            handleSizeChange(val) {
                let that = this;
                if (that.selectIndex == 0) {
                    that.pageSize = val;
                    this.$http.savePageSize('purschemeview',val)
                } else if (that.selectIndex == 1) {
                    that.pageSize1 = val;
                    this.$http.savePageSize('purschemeview1',val)
                } else if (that.selectIndex == 2) {
                    that.pageSize2 = val;
                    this.$http.savePageSize('purschemeview2',val)
                } else if (that.selectIndex == 3) {
                    that.pageSize3 = val;
                    this.$http.savePageSize('purschemeview3',val)
                }
                that.getView();
                that.authority();
            },
            handleCurrentChange(val) {
                let that = this;
                if (that.selectIndex == 0) {
                    that.pageIndex = val;
                } else if (that.selectIndex == 1) {
                    that.pageIndex1 = val;
                } else if (that.selectIndex == 2) {
                    that.pageIndex2 = val;
                } else if (that.selectIndex == 3) {
                    that.pageIndex3 = val;
                }
                that.getView();
                that.authority();
            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'PurRequisitionViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },
            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    selectIndex: 0,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Requisition/DataList', data, function (res) {
                    if (res.Success == 1) {
                        that.dataSet = res.DataContent;
                        that.total = res.Totals;
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                        that.$nextTick(function(){
                            that.$processdata.initForm(0)
                        });
                    }
                    that.authority();
                });
                let data1 = {
                    PageIndex: that.pageIndex1,
                    PageSize: that.pageSize1,
                    selectIndex: 1,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Requisition/DataList', data1, function (res) {
                    if (res.Success == 1) {
                        that.dataSet1 = res.DataContent;
                        that.total1 = res.Totals;
                        that.$nextTick(function(){
                            that.$processdata.initForm(1)
                        });
                    }
                });
                let data2 = {
                    PageIndex: that.pageIndex2,
                    PageSize: that.pageSize2,
                    selectIndex: 2,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Requisition/DataList', data2, function (res) {
                    if (res.Success == 1) {
                        that.dataSet2 = res.DataContent;
                        that.total2 = res.Totals;
                        that.$nextTick(function(){
                            that.$processdata.initForm(2)
                        });
                    }
                });
                let data3 = {
                    PageIndex: that.pageIndex3,
                    PageSize: that.pageSize3,
                    selectIndex: 3,
                    Param: datac
                };
                that.$http.urlpost('/Pur/Requisition/DataList', data3, function (res) {
                    if (res.Success == 1) {
                        that.dataSet3 = res.DataContent;
                        that.total3 = res.Totals;
                        that.$nextTick(function(){
                            that.$processdata.initForm(3)
                        });
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this;
                if(that.Requisition_No == row.Requisition_No){
                    return
                }
                that.timeId = setTimeout(() => {
                    if(!this.$limits.menuvisible("plv2", 58, 1)){
                        return
                    }
                    let datacopy = that.dataDetail
                    for(let i = 0;i<datacopy.Lists.length;i++){
                        delete datacopy.Lists[i]['index']
                        delete datacopy.Lists[i]['_XID'];
                    }
                    if(that.oldDataDetail != JSON.stringify(datacopy)){
                        that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                            confirmButtonText: that.$t('getapi[2052]'),
                            cancelButtonText: that.$t('getapi[2053]'),
                            closeOnClickModal: false,
                            type: 'warning'
                        })
                            .then(() => {
                                that.oldselectIndex = that.activeName
                                that.iscontinuedblclick = true
                                that.oldrow = row
                                that.isShowEdit = true;
                                that.Requisition_No = row.Requisition_No;
                                that.getDetail(row.Requisition_No);
                            })
                            .catch(() => {
                                that.iscontinuedblclick = false
                                if (that.oldselectIndex == 0) {
                                    that.$refs.singleTable.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldselectIndex == 1) {
                                    that.$refs.singleTable1.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldselectIndex == 2) {
                                    that.$refs.singleTable2.$refs.singleTable.setCurrentRow(that.oldrow);
                                } else if (that.oldselectIndex == 3) {
                                    that.$refs.singleTable3.$refs.singleTable.setCurrentRow(that.oldrow);
                                }
                                that.activeName = that.oldselectIndex
                            });
                    } else {
                        that.oldselectIndex = that.activeName
                        that.iscontinuedblclick = true
                        that.oldrow = row
                        that.isShowEdit = true;
                        that.Requisition_No = row.Requisition_No;
                        that.getDetail(row.Requisition_No);
                    }
                }, 100);
            },
            // 获取详情数据
            getDetail(code) {
                let that = this;
                that.addoredit = 2;
                let parm = {
                    Code: code
                };
                let loadingInstance = Loading.service(Common.maskoption);
                that.$http.urlpost('/Pur/Requisition/PurRequisitionBillInfo', parm, function (res) {
                    if (res.Success == 1) {
                        that.dataDetail = res.DataContent;
                        that.selectData = [];
                        that.dataChecked = [];
                        that.dataDetail.Head.flag = 1
                        that.BatchPriceLine = that.dataDetail.BatchPriceLine
                        if(that.dataDetail.BatchPriceLine.length > 0){
                            for(let i = 0;i<that.dataDetail.Lists.length;i++){
                                if(that.dataDetail.Lists[i].minbatchprice_color > 0){
                                    let price = that.dataDetail.Lists[i].net_unit_price
                                    for(let j=0;j<that.dataDetail.BatchPriceLine.length;j++){
                                        if(that.dataDetail.Lists[i].part_code ==that.dataDetail.BatchPriceLine[j].part_code && that.dataDetail.Lists[i].part_version ==that.dataDetail.BatchPriceLine[j].part_version  && that.dataDetail.Lists[i].plan_qty >= that.dataDetail.BatchPriceLine[j].batch_floor_limit){
                                            price = that.dataDetail.BatchPriceLine[j].net_price
                                        }
                                    }
                                    let row1 = that.dataDetail.BatchPriceLine.find(item => item.part_code == that.dataDetail.Lists[i].part_code && item.part_version == that.dataDetail.Lists[i].part_version && item.batch_floor_limit > that.dataDetail.Lists[i].plan_qty)
                                    if(row1 != undefined){
                                        if((that.dataDetail.Lists[i].plan_qty * price) > (row1.batch_floor_limit * row1.net_price * 0.8)){
                                            that.dataDetail.Lists[i].purrec = that.$t('getapi[12522]')
                                        }
                                    }
                                }
                            }
                        }
                        that.selectbtn();
                        that.authority();
                        that.btnauthority();
                        that.oldDataDetail = JSON.stringify(that.dataDetail)
                        that.rowindex = -1
                        that.$nextTick(function(){
                            that.$processdata.initFormRight(this.RightselectIndex)
                        });
                    }
                    loadingInstance.close()
                });
            },
            pinSelect (item, index) {
                console.log('select事件')
                setTimeout(() => {
                    const data = this.$refs.singleTable4.tableData // 获取所有数据
                    const origin = this.origin // 起点数 从-1开始
                    const endIdx = index.index // 终点数
                    if (this.pin && item.includes(data[origin])) { // 判断按住
                        const sum = Math.abs(origin - endIdx) + 1// 这里记录终点
                        const min = Math.min(origin, endIdx)// 这里记录起点
                        for(let i=0;i<sum;i++){
                            this.$refs.singleTable4.toggleRowSelection(data[min+i], true)
                        }
                        /*let i = 0
                        while (i < sum) {
                            const index = min + i
                            this.$refs.singleTable4.toggleRowSelection(data[index], true)// 通过ref打点调用toggleRowSelection方法，第二个必须为true
                            i++
                        }*/
                    } else {
                        this.origin = index.index // 没按住记录起点
                    }
                }, 100);
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                    delete datacopy.Lists[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.confirmAdd()
                            that.openEdit()
                        });
                } else {
                    that.confirmAdd()
                    that.openEdit()
                }
            },
            confirmAdd(){
                let that = this;
                that.addoredit = 1;
                let datetime = Common.methods.getDatetime()
                that.isShowEdit = true;
                that.Requisition_No = ''
                that.dataDetail = {
                    Head: {
                        row_number: 0,
                        requisition_no: '',
                        item_code: '',
                        requisition_type_id: that.$limits.getDefaultSelect(that.PlanTypeArray, 'Code'),//计划类型：默认 订购点计划
                        requisition_type: '',
                        purmannerid: 0,
                        purtypeid: 0,
                        purmannername: '',
                        purtypename: '',
                        create_time: datetime,
                        create_person: that.user,
                        audit_time: '',
                        audit_person: '',
                        modify_time: datetime,
                        modify_person: that.user,
                        requisition_status: 0,
                        remark: '',
                        trace: 0,
                        flag: 0,
                        pur_request_inst:''
                    },
                    Lists: [],
                };
                that.BatchPriceLine = []
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();
                if (that.addoredit != 1) {
                    that.getDetail(that.Requisition_No)
                } else {
                    that.add()
                }*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                    delete datacopy.Lists[i]['_XID'];
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            if(that.addoredit != 1){
                                that.getView();
                                that.getDetail(that.Requisition_No)
                            } else {
                                that.getView();
                                that.confirmAdd()
                            }
                        });
                } else {
                    if(that.addoredit != 1){
                        that.getView();
                        that.getDetail(that.Requisition_No)
                    } else {
                        that.getView();
                        that.confirmAdd()
                    }
                }
            },
            // 导出
            exps() {
                /*let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    selectIndex: that.selectIndex,
                    Ids: '',
                    Param: datac
                };
                that.$refs.SetBtn.SetOneBtnEnable('exps', false);
                that.$http.urlpost('/Pur/Requisition/ExportToExecl', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps', true);
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });*/
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    query_sign: "PurRequisitionViewInfo",
                    fromname: that.$t('getapi[1138]'),
                    selectIndex: 0,
                    MultyVer: that.$processdata.getLanguage(),
                    Param: datac
                };
                that.$processdata.commonExport(parm)
            },
            imp() {
                let item = {
                    //label: '采购计划导入',
                    label: '通用导入',
                    name: 'exp',
                    path: '/exp/8',
                    url: '/exp/8',
                    icon: 'video-play'
                };
                this.$router.push({path: '/exp/8'});
                this.$store.commit('selectMenu', item);
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail;
                let devicedidflag = false
                if(that.dataDetail.Head.requisition_type.toUpperCase().includes('固资')){
                    for(let i=0;i<that.dataDetail.Lists.length;i++){
                        if(that.dataDetail.Lists[i].plan_qty == 1 && that.$limits.fnIsEmpty(that.dataDetail.Lists[i].deviceid)){
                            that.$message.warning(that.$t('getapi[530]')+(i+1)+that.$t('getapi[532]')+','+that.$t('getapi[9241]'))
                            return
                        }
                    }
                    for(let i=0;i<that.dataDetail.Lists.length;i++){
                        if(that.$limits.fnIsEmpty(that.dataDetail.Lists[i].deviceid)){
                            devicedidflag = true
                            break;
                        }
                    }
                }
                if(devicedidflag){
                    this.$confirm(that.$t('getapi[12827]'), that.$t('getapi[194]'), {//'确定删除数据?'
                        confirmButtonText: that.$t('getapi[1146]'),
                        cancelButtonText: that.$t('getapi[2054]'),
                        type: 'warning'
                    })
                        .then(() => {
                            if(that.addoredit == 1){
                                if(that.mro_only && !that.dataDetail.Head.requisition_type.toUpperCase().includes('MRO')){
                                    that.$message.warning(that.$t('getapi[8764]'))//'权限只允许创建MRO计划，不能创建其它计划!'
                                    return false
                                }
                                if(that.mro_no && that.dataDetail.Head.requisition_type.toUpperCase().includes('MRO')){
                                    that.$message.warning(that.$t('getapi[8765]'))//'权限只允许创建非MRO计划，不能创建MRO计划!'
                                    return false
                                }
                                if(that.dataDetail.Head.requisition_type == 'MRO计划'){
                                    if(!that.dataDetail.Head.requisition_no.toUpperCase().startsWith('MRO')){
                                        that.$message.warning(that.$t('getapi[8766]'))//'MRO计划，计划标识必须MRO开头!'
                                        return false
                                    }
                                    for(let i = 0;i<that.dataDetail.Lists.length;i++){
                                        if(!that.dataDetail.Lists[i].part_code.toUpperCase().startsWith('MRO')){
                                            that.$message.warning(that.$t('getapi[8767]'));//"MRO计划，物料编码必须MRO开头"
                                            return false;
                                        }
                                    }
                                }
                            }
                            that.$refs.SetBtn.SetOneBtnEnable('save', false);
                            that.$http.urlpost('/Pur/Requisition/SaveData', parm, function (res) {
                                that.$refs.SetBtn.SetOneBtnEnable('save', true);
                                if (res.Success == 1) {
                                    that.isShowEdit = false;
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    that.Requisition_No = that.dataDetail.Head.requisition_no;
                                    that.getDetail(that.Requisition_No);
                                }
                            });
                        })
                        .catch(() => {
                            this.$message({
                                type: 'info',
                                message: that.$t('getapi[6096]')
                            });
                        });
                } else {
                    if(that.addoredit == 1){
                        if(that.mro_only && !that.dataDetail.Head.requisition_type.toUpperCase().includes('MRO')){
                            that.$message.warning(that.$t('getapi[8764]'))//'权限只允许创建MRO计划，不能创建其它计划!'
                            return false
                        }
                        if(that.mro_no && that.dataDetail.Head.requisition_type.toUpperCase().includes('MRO')){
                            that.$message.warning(that.$t('getapi[8765]'))//'权限只允许创建非MRO计划，不能创建MRO计划!'
                            return false
                        }
                        if(that.dataDetail.Head.requisition_type == 'MRO计划'){
                            if(!that.dataDetail.Head.requisition_no.toUpperCase().startsWith('MRO')){
                                that.$message.warning(that.$t('getapi[8766]'))//'MRO计划，计划标识必须MRO开头!'
                                return false
                            }
                            for(let i = 0;i<that.dataDetail.Lists.length;i++){
                                if(!that.dataDetail.Lists[i].part_code.toUpperCase().startsWith('MRO')){
                                    that.$message.warning(that.$t('getapi[8767]'));//"MRO计划，物料编码必须MRO开头"
                                    return false;
                                }
                            }
                        }
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', false);
                    that.$http.urlpost('/Pur/Requisition/SaveData', parm, function (res) {
                        that.$refs.SetBtn.SetOneBtnEnable('save', true);
                        if (res.Success == 1) {
                            that.isShowEdit = false;
                            that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                            that.Requisition_No = that.dataDetail.Head.requisition_no;
                            that.getDetail(that.Requisition_No);
                        }
                    });
                }
            },
            // 切换页签
            selectInfo(tab) {
                let that = this;
                that.activeName = tab.name;
                that.selectIndex = tab.name;
                that.$nextTick(function(){
                    that.$processdata.initForm(tab.name)
                });
                /*if (that.selectIndex == 0 && that.dataSet.length != 0) {
                    that.setCurrent(that.currentRow);
                    that.editInfo(that.currentRow);
                } else if (that.selectIndex == 1 && that.dataSet1.length != 0) {
                    that.setCurrent1(that.currentRow1);
                    that.editInfo(that.currentRow1);
                } else if (that.selectIndex == 2 && that.dataSet2.length != 0) {
                    that.setCurrent2(that.currentRow2);
                    that.editInfo(that.currentRow2);
                } else if (that.selectIndex == 3 && that.dataSet3.length != 0) {
                    that.setCurrent3(that.currentRow3);
                    that.editInfo(that.currentRow3);
                } else {
                    that.getView();
                }*/
            },
            handleSelectionChange({records}) {
                let that = this;
                that.isBtnPlan = true;
                that.isBtnPlanReturn = true;
                that.isBtnDel = true;
                that.selectData = [];
                that.dataChecked = [];
                that.selectData = records
                for (let i = 0; i < records.length; i++) {
                    that.dataChecked.push(records[i].exclusively_id);
                }
                console.log(that.selectData.length)
                for (let i = 0; i < that.selectData.length; i++) {
                    if (that.selectData[i].line_status == '已下单') {
                        that.isBtnPlan = true;
                        that.isBtnPlanReturn = true;
                        that.isBtnDel = true;
                        return;
                    }
                }
                that.selectData.every(val => {
                    if (val.line_status == '生成') {
                        that.isBtnPlan = true;
                        that.isBtnPlanReturn = false;
                        that.isBtnDel = true;
                    }
                });
                that.selectData.every(val => {
                    if (val.line_status == '下达') {
                        that.isBtnPlan = true;
                        that.isBtnPlanReturn = false;
                        that.isBtnDel = true;
                    }
                });
                that.selectbtn();
            },
            //
            editInfo1() {
            },
            editInfo2() {
            },
            editInfo3() {
            },
            selectItem_code() {
                let that = this;
                that.isShowItem = true;
                that.$refs.input.clearInput(this.isShowItem, false, 0);
            },
            getproject(val) {
                let that = this;
                console.log(val)
                that.dataDetail.Head.item_code = val.item_name;
                if(val.trace=="是"){
                    that.dataDetail.Head.trace=1;
                }
                else{
                    that.dataDetail.Head.trace=0;
                }
            },
            showAddBom(row) {
                let that = this;
                if(that.$limits.authority('plv4', 76, 1) != 1){
                    that.$message.warning(that.$t('getapi[8750]'))//'没有开通选择物料的权限!'
                    return false
                }
                if (row != '') {
                    this.rowindex = row.$rowIndex;
                }
                that.addbomvisible = true;
                that.oneormore = 1; //单条
                that.$refs.addmaterial.clearInput(that.addbomvisible);
            },
            showAddBill(row) {
                let that = this;
                if(that.$limits.authority('plv4', 76, 1) != 1){
                    that.$message.warning(that.$t('getapi[8750]'))//'没有开通选择物料的权限!'
                    return false
                }
                if (row != '') {
                    this.rowindex = row.$rowIndex;
                }
                that.$refs.addbill.clearInput(true);
            },
            addbill(row){
                let that = this
                console.log(row)
                that.dataDetail.Lists[this.rowindex].billcode = row.billcode
            },
            showAddBatchBom() {
                let that = this;
                if(that.$limits.authority('plv4', 76, 1) != 1){
                    that.$message.warning(that.$t('getapi[8750]'))//'没有开通选择物料的权限!'
                    return false
                }
                that.addbomvisible = true;
                that.oneormore = 2; //批量
                that.$refs.addmaterials.clearInput(that.addbomvisible);
            },
            addmaterials(row) {
                let that = this;
                let date = Common.methods.getDate();
                console.log(row);
                if (that.oneormore == 1) {
                    if (this.rowindex < this.dataDetail.Lists.length && this.rowindex != -1) {
                        this.dataDetail.Lists[this.rowindex].exclusively_id = '';
                        this.dataDetail.Lists[this.rowindex].part_code = row.part_code;
                        this.dataDetail.Lists[this.rowindex].part_name = row.part_name;
                        this.dataDetail.Lists[this.rowindex].part_version = row.part_version;
                        this.dataDetail.Lists[this.rowindex].specification = row.part_spec;
                        this.dataDetail.Lists[this.rowindex].model = row.part_model;
                        this.dataDetail.Lists[this.rowindex].part_stuff = row.part_stuff;
                        this.dataDetail.Lists[this.rowindex].expect_ship_date = '';
                        this.dataDetail.Lists[this.rowindex].pur_measurementunit = row.pur_measurementunit;
                        this.dataDetail.Lists[this.rowindex].inventory_qty = row.qty_on_hand;
                        this.dataDetail.Lists[this.rowindex].material_std_code = row.quality_std;
                        this.dataDetail.Lists[this.rowindex].key_flag = row.key_flag;
                        this.dataDetail.Lists[this.rowindex].purchase_leadtime = row.purchase_leadtime;
                        this.dataDetail.Lists[this.rowindex].isdel = 0;
                        this.dataDetail.Lists[this.rowindex].isadd = 0;
                        this.dataDetail.Lists[this.rowindex].deviceid = '';
                        this.dataDetail.Lists[this.rowindex].purrec = ''
                        this.dataDetail.Lists[this.rowindex].tiersprice = row.tiersprice;
                        this.dataDetail.List[this.rowindex].billcode = ''
                        let parm = {
                            part_code: this.dataDetail.Lists[this.rowindex].part_code,
                            part_version: this.dataDetail.Lists[this.rowindex].part_version
                        }
                        that.$http.urlpost('/Pur/Requisition/GetBatchPriceData', parm, function (res) {
                            if (res.Success == 1) {
                                if(that.BatchPriceLine.length > 0){
                                    let flag = false
                                    for(let i = 0;i<that.BatchPriceLine.length;i++){
                                        if(this.dataDetail.Lists[this.rowindex].part_code == res.DataContent.BatchPriceLine[0].part_code && this.dataDetail.Lists[this.rowindex].part_version == res.DataContent.BatchPriceLine[0].part_version){
                                            flag = true
                                            break
                                        }
                                    }
                                    if(!flag){
                                        that.BatchPriceLine = [...that.BatchPriceLine,{
                                            part_code: res.DataContent.BatchPriceLine[0].part_code,
                                            part_version: res.DataContent.BatchPriceLine[0].part_version,
                                            batch_floor_limit: res.DataContent.BatchPriceLine[0].batch_floor_limit
                                        }]
                                    }
                                } else {
                                    that.BatchPriceLine = [...that.BatchPriceLine,{
                                        part_code: res.DataContent.BatchPriceLine[0].part_code,
                                        part_version: res.DataContent.BatchPriceLine[0].part_version,
                                        batch_floor_limit: res.DataContent.BatchPriceLine[0].batch_floor_limit
                                    }]
                                }
                            }
                        });
                    } else {
                        that.dataDetail.Lists = [
                            ...that.dataDetail.Lists,
                            {
                                row_number: that.dataDetailLineNo++,
                                exclusively_id: '',
                                part_code: row.part_code,
                                part_name: row.part_name,
                                part_version: row.part_version,
                                specification: row.part_spec,
                                model: row.part_model,
                                part_stuff: row.part_stuff,
                                expect_ship_date: '',
                                pur_measurementunit: row.pur_measurementunit,
                                inventory_qty: row.qty_on_hand,
                                material_std_code: row.quality_std,
                                line_status: '生成',
                                key_flag: row.key_flag,
                                purchase_leadtime: row.purchase_leadtime,
                                tiersprice: row.tiersprice,                                
                                isdel: 0,
                                isadd: 1,
                                deviceid: '',
                                purrec:'',
                                billcode:'',
                            }
                        ];
                    }
                } else if (that.oneormore == 2) {
                    that.dataDetailLineNo = 1
                    for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                        if (that.dataDetail.Lists[i].row_number >= that.dataDetailLineNo) {
                            that.dataDetailLineNo = that.dataDetail.Lists[i].row_number + 1
                        }
                    }
                    for (let i = 0; i < row.length; i++) {
                        let parm = {
                            part_code: row[i].part_code,
                            part_version: row[i].part_version
                        }
                        that.$http.urlpost('/Pur/Requisition/GetBatchPriceData', parm, function (res) {
                            if (res.Success == 1) {
                                if(that.BatchPriceLine.length > 0){
                                    let flag = false
                                    for(let j = 0;j<that.BatchPriceLine.length;j++){
                                        if(that.BatchPriceLine[j].part_code == res.DataContent.BatchPriceLine[0].part_code && that.BatchPriceLine[j].part_version == res.DataContent.BatchPriceLine[0].part_version){
                                            flag = true
                                            break
                                        }
                                    }
                                    if(!flag){
                                        that.BatchPriceLine = [...that.BatchPriceLine,{
                                            part_code: res.DataContent.BatchPriceLine[0].part_code,
                                            part_version: res.DataContent.BatchPriceLine[0].part_version,
                                            batch_floor_limit: res.DataContent.BatchPriceLine[0].batch_floor_limit
                                        }]
                                    }
                                } else {
                                    that.BatchPriceLine = [...that.BatchPriceLine,{
                                        part_code: res.DataContent.BatchPriceLine[0].part_code,
                                        part_version: res.DataContent.BatchPriceLine[0].part_version,
                                        batch_floor_limit: res.DataContent.BatchPriceLine[0].batch_floor_limit
                                    }]
                                }
                            }
                        });
                        that.dataDetail.Lists = [
                            ...that.dataDetail.Lists,
                            {
                                row_number: that.dataDetailLineNo++,
                                exclusively_id: '',
                                part_code: row[i].part_code,
                                part_name: row[i].part_name,
                                part_version: row[i].part_version,
                                specification: row[i].part_spec,
                                model: row[i].part_model,
                                part_stuff: row[i].part_stuff,
                                expect_ship_date: '',
                                pur_measurementunit: row[i].pur_measurementunit,
                                inventory_qty: row[i].qty_on_hand,
                                material_std_code: row[i].quality_std,
                                tiersprice: row[i].tiersprice, 
                                line_status: '生成',
                                isdel: 0,
                                isadd: 1,
                                deviceid: '',
                                billcode:'',
                            }
                        ];
                    }
                }
            },
            expStatus(val) {
                let that = this
                if (val == 0) {
                    return that.$t('getapi[1422]');//'生成'
                } else if (val == 1) {
                    return that.$t('getapi[1488]');//'下达'
                } else if (val == 2) {
                    return that.$t('getapi[1489]');//'已下单'
                } else {
                    return '';
                }
            },
            // 从旧计划拷贝
            copyByOld() {
                let that = this;
                that.isShowCopy = true;
                that.$refs.copy.clearInput(that.isShowCopy);
            },
            copy(data) {
                let that = this;
                let parm = {
                    Code: data.requisition_no
                };
                that.$http.urlpost('/Pur/Requisition/PurRequisitionLinesByOldId', parm, function (res) {
                    if (res.Success == 1) {
                        let row = res.DataContent;
                        for (let i = 0; i < that.dataDetail.Lists.length; i++) {
                            if (that.dataDetail.Lists[i].row_number >= that.dataDetailLineNo) {
                                that.dataDetailLineNo = that.dataDetail.Lists[i].row_number + 1
                            }
                        }
                        for (let i = 0; i < row.length; i++) {
                            that.dataDetail.Lists = [
                                ...that.dataDetail.Lists,
                                {
                                    row_number:  that.dataDetailLineNo++,
                                    exclusively_id: row[i].exclusively_id,
                                    part_code: row[i].part_code,
                                    part_name: row[i].part_name,
                                    part_version: row[i].part_version,
                                    specification: row[i].part_spec,
                                    model: row[i].part_model,
                                    part_stuff: row[i].part_stuff,
                                    expect_ship_date: row[i].purchase_leadtime,
                                    pur_measurementunit: row[i].pur_measurementunit,
                                    inventory_qty: row[i].qty_on_hand,
                                    material_std_code: row[i].quality_std,
                                    line_status: row[i].line_status,
                                    isdel: 0,
                                    isadd: 1,
                                    billcode:row[i].billcode,
                                }
                            ];
                        }
                    }
                });
            },
            // 批量删除
            batchDel() {
                let that = this;
                console.log('删除' + that.selectData.length)
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            requisition_no: that.dataDetail.Head.requisition_no,
                            Lists: []
                        };
                        that.selectData = that.selectData.sort(that.$processdata.compare('index'))
                        for (let i = that.selectData.length - 1; i >= 0; i--) {
                            that.dataDetail.Lists.splice(that.selectData[i].index, 1);
                            if (!that.$limits.fnIsEmpty(that.selectData[i].exclusively_id)) {
                                let datatmp = {
                                    exclusively_id: that.selectData[i].exclusively_id,
                                    relation_requisition_no: that.selectData[i].relation_requisition_no,
                                }
                                parm.Lists.push(datatmp);
                            }
                        }
                        that.selectData = []
                        if (parm.Lists.length > 0) {
                            that.$http.urlpost('/Pur/Requisition/DelRequisitionLine', parm, function (res) {
                                if (res.Success == 1) {
                                    that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                    if (!that.$limits.fnIsEmpty(that.Requisition_No)) {
                                        that.getDetail(that.Requisition_No);
                                    }
                                }
                            });
                        } else {
                            that.selectbtn()
                        }
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            planRelease() {
                let that = this;
                let arr = [];
                for (let i = 0; i < that.selectData.length; i++) {
                    arr.push({
                        exclusively_id: that.selectData[i].exclusively_id,
                        row_number: that.selectData[i].row_number
                    });
                }
                let parm = {
                    requisition_no: that.dataDetail.Head.requisition_no,
                    Lines: arr
                };
                that.btn.release = false
                that.$http.urlpost('/Pur/Requisition/PurReceiveLineCheck', parm, function (res) {
                    that.btn.release = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.Requisition_No);
                    }
                });
            },
            planReturn() {
                let that = this;
                let arr = [];
                for (let i = 0; i < that.selectData.length; i++) {
                    arr.push({
                        exclusively_id: that.selectData[i].exclusively_id,
                        row_number: that.selectData[i].row_number
                    });
                }
                let parm = {
                    requisition_no: that.dataDetail.Head.requisition_no,
                    requisition_status: that.dataDetail.Head.requisition_status,
                    Lines: arr
                };
                that.btn.create = false
                that.$http.urlpost('/Pur/Requisition/PurRequisitionPlanRBuild', parm, function (res) {
                    that.btn.create = true
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.Requisition_No);
                    }
                });
            },
            // 删除单据
            del() {
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            requisition_no: that.dataDetail.Head.requisition_no,
                            requisition_status: that.dataDetail.Head.requisition_status
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del', false);
                        that.$http.urlpost('/Pur/Requisition/DelPurRequisition', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del', true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            showdeviceid(row) {
                let that = this;
                that.rowindexdevice = row.$rowIndex;
                that.$refs.device.clearInput(true);
            },
            getdevice(data) {
                let that = this
                console.log(data)
                console.log(that.rowindexdevice)
                that.dataDetail.Lists[that.rowindexdevice].deviceid = data.deviceid;
            },
            // 更新统计列
            updateStaticCols(){
                let that = this
                let parm = {
                  Code: that.dataDetail.Head.requisition_no
                }
                that.$http.urlpost('/Pur/Requisition/PurRequisitionUpdateStaticCols', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getDetail(that.Requisition_No);
                    }
                });
            },
            editDetailInfo({row}){
                let that = this
                that.rowindex = row.index
            },
            sortChange(column){
                let that = this
                let name = column.property
                console.log(column)
                if(column.order == "asc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return -1;
                        } else if (val1 > val2) {
                            return 1;
                        } else {
                            return that.dataDetail.Lists.indexOf(obj1) - that.dataDetail.Lists.indexOf(obj2);
                        }
                    }
                    that.dataDetail.Lists = that.dataDetail.Lists.sort(compare);
                } else if(column.order == "desc"){
                    let compare = function (obj1, obj2) {
                        let val1 = obj1[name];
                        let val2 = obj2[name];
                        if (val1 < val2) {
                            return 1;
                        } else if (val1 > val2) {
                            return -1;
                        } else {
                            return that.dataDetail.Lists.indexOf(obj2) - that.dataDetail.Lists.indexOf(obj1);
                        }
                    }
                    that.dataDetail.Lists = that.dataDetail.Lists.sort(compare);
                }
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 58,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.Lists.length;i++){
                    delete datacopy.Lists[i]['index']
                    delete datacopy.Lists[i]['_XID'];
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            },
        }
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .red {
        background: #ff7879;
    }

    /deep/ .green {
        background: #c8ffbb;
    }

    /deep/ .hidden {
        display: none;
    }
    /deep/ .yellow {
        background: #fff866;
    }
</style>
